import React from 'react';
import { WarningFilled } from '@tag/tag-icons';

import AgModalWindow from '@/components/common/ModalWindow/AgModalWindow';


interface IEndDatePassedModalProps {
  onClose: () => void;
}

export default function EndDatePassedModal({ onClose }: IEndDatePassedModalProps) {
  return (
    <AgModalWindow
      isOpen={true}
      onClose={onClose}
      title="You are about to mark this Contract/Contract Line as Active"
      contentStyle={{ width: 600 }}
      headerIcon={(
        <WarningFilled size="32" fill="#e8ad44 !important" />
      )}
    >
      <div className="mt-20 mb-20 fz-14">
        You cannot approve the contract lines since contract end date has already passed
      </div>
    </AgModalWindow>
  );
}
